export const boostersTypesNames = {
    invisibility:'invisibility',
    increaseStepDistance:'increase step distance',
    bishopStep:'bishop step',
}